<template>
  <transition-group name="listitem">
    <slot />
  </transition-group>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
.listitem-move,
/* apply transition to moving elements */
.listitem-enter-active,
.listitem-leave-active {
  transition: all 0.5s ease;
}

.listitem-enter-from,
.listitem-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
